import gif from "./gifs/Blocks-0.7s-200px.gif";

const BlocksSpinner = () => {
  return (
    <>
      <img src={gif} alt="loading..." />
    </>
  );
};

export default BlocksSpinner;
